<template>
  <div class="backoffice-login-stage">
    <b-loading
      :is-full-page="isFullPage"
      :active.sync="isLoading"
      :can-cancel="true"
    />
    <main class="container" id="maincontent">
      <a @click.prevent="reloadComponent()" class="back-link" v-if="cardStep">
        <i class="icon-ic_arrow_left_blue" />
        Voltar
      </a>
      <section class="login-section" v-if="!state.page">
        <a
          href="https://www.sarah.br/"
          target="_blank"
          class="back-link"
          v-if="!cardStep"
        >
          <i class="icon-ic_link" /> {{ this.$t('login.ir_para_sarah') }}
        </a>
        <div class="img-container hide-on-small">
          <img
            class="login-section_logo"
            v-if="!activeTab"
            src="~@/assets/images/banners/doctors_banner.svg"
            alt="Doutores"
          />
          <img
            class="login-section_logo"
            v-else
            src="~@/assets/images/banners/first_access.svg"
            alt="Primeiro Acesso"
          />
        </div>
        <b-tabs v-model="activeTab" v-if="!cardStep">
          <b-tab-item :label="loginLabel">
            <div class="login-section_box">
              <span class="register-active" v-if="validated">
                Sua conta da Rede SARAH foi ativada
              </span>
              <slot name="login-stage" />
            </div>
          </b-tab-item>
          <b-tab-item label="Fazer cadastro" v-if="this.releaseSolicitacao">
            <FirstAccess @next-step="cardStep = true" />
          </b-tab-item>
        </b-tabs>
        <div class="card-container" v-show="cardStep">
          <h2>{{ $t('first_access.cards_title') }}</h2>
          <h3>{{ $t('first_access.cards_subtitle') }}</h3>
          <cards-recovery
            v-for="card in cards"
            :key="card.title"
            :title="card.title"
            :description="card.email ? newUserData.email : newUserData.cel"
            @checkType="
              () => {
                card.email
                  ? (emailConfirmation = true)
                  : (emailConfirmation = false)
                sendNewUserInfo()
              }
            "
          />
        </div>
      </section>
      <state-response
        v-if="state.page"
        :state-title="state.title"
        :state-text="state.text"
        :bold-text="state.boldText"
        :button-text="state.buttonText"
        :status-ok="state.statusOk"
        @action-fn="reloadComponent"
      />
    </main>
  </div>
</template>
<script>
import FirstAccess from '@/components/login/FirstAccess'
import CardsRecovery from '@/components/shared/cards/CardsRecovery'
import StateResponse from '@/components/login/StateResponse'
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'LoginStage',
  components: {
    FirstAccess,
    CardsRecovery,
    StateResponse
  },
  data() {
    return {
      isLoading: false,
      isFullPage: true,
      activeTab: 0,
      loginLabel: this.$t('login.entrar'),
      cardStep: false,
      emailConfirmation: null,
      cards: [
        { title: 'Via e-mail', email: true },
        { title: 'Por celular', email: false }
      ],
      state: {
        page: false,
        title: '',
        text: '',
        buttonText: '',
        statusOk: true,
        boldText: ''
      },
      validated: false,
      code: this.$route.query.Code
    }
  },
  computed: {
    ...mapGetters({
      newUserData: 'getNewUserData'
    }),
    disabledButton() {
      return this.emailConfirmation !== undefined
    },
    releaseSolicitacao() {
      return process.env.VUE_APP_SOLICITACAO_RELEASE !== 'false'
    }
  },
  mounted() {
    if (this.code) this.userValidation()
  },
  methods: {
    ...mapActions(['setNewUserAction', 'validateRegisterAction']),
    emailResponse() {
      this.state = {
        page: true,
        title: 'Verifique seu e-mail',
        text: 'Enviamos um e-mail de confirmação para ',
        boldText: this.newUserData.email,
        buttonText: 'Entrar',
        statusOk: true
      }
    },
    smsResponse() {
      this.state = {
        page: true,
        title: 'Verifique seu telefone',
        text: 'Enviamos um sms de confirmação para ',
        boldText: this.newUserData.cel,
        buttonText: 'Entrar',
        statusOk: true
      }
    },
    async sendNewUserInfo() {
      this.isLoading = true
      const payload = {
        userName: this.newUserData.name,
        userCpf: this.newUserData.cpf.replace(/[^\d]+/g, ''),
        userEmail: this.newUserData.email,
        userCel: this.newUserData.cel.replace(/[^\d]+/g, ''),
        userPassword: this.newUserData.password,
        emailConfirmation: this.emailConfirmation
      }
      try {
        await this.setNewUserAction(payload)
        this.isLoading = false
        this.emailConfirmation ? this.emailResponse() : this.smsResponse()
      } catch (error) {
        this.isLoading = false
        this.state = {
          page: true,
          title: 'Algo deu errado',
          text: error,
          buttonText: 'Tentar novamente',
          statusOk: false
        }
      }
    },
    async userValidation() {
      this.isLoading = true
      try {
        await this.validateRegisterAction(this.code)
        this.$router.push(this.$route.path)
        this.validated = true
        this.isLoading = false
      } catch (error) {
        this.$router.push(this.$route.path)
        this.isLoading = false
      }
    },
    reloadComponent() {
      window.location.reload(true)
      this.isLoading = true
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~@/assets/stylesheets/base';

.app-view.backoffice-login-stage {
  height: 100%;
  padding-top: 5.875rem;
  min-height: 107vh;
  padding-bottom: 0;
  h2 {
    font-size: 1.25rem;
    font-weight: 500;
    margin-bottom: 1.25rem;

    color: var(--gray-700);
  }
  h3 {
    font-size: 1rem;

    color: var(--gray-700);
    line-height: 1.5rem;
    margin-bottom: 1.25rem;
  }
  main {
    height: 100%;

    background-color: var(--bg-color-primary);
    box-sizing: border-box;
    .login-section {
      .register-active {
        margin: 1.3rem 0 -0.7rem;
        display: block;
        font-weight: $font-bold;

        font-size: 0.9rem;

        color: var(--green);
        background-color: #acf9c0;
        padding: 0.625rem 1.1rem;
      }
      .img-container {
        width: 100%;
        img {
          margin: 0 auto;
        }
      }
      .b-tabs {
        max-width: 450px;
        min-height: 404px;
        .tabs ul {
          li {
            width: 50%;
          }
        }
      }
    }
    .card-container {
      width: 100%;
      margin-top: 4rem;
    }
  }
}

//Responsive mode
@media (min-width: 768px) {
  .app-view.backoffice-login-stage {
    padding-top: 13.875rem;
    padding-bottom: 2rem;
    min-height: 100%;
    main {
      .login-section {
        display: flex;
        .img-container {
          width: 50%;
        }
        .b-tabs {
          width: 50%;
        }
      }
      .card-container {
        width: 40%;
      }
    }
  }
}
</style>
